import { render, staticRenderFns } from "./subjectiveQuestions.vue?vue&type=template&id=4d20e661&scoped=true&"
import script from "./subjectiveQuestions.vue?vue&type=script&lang=js&"
export * from "./subjectiveQuestions.vue?vue&type=script&lang=js&"
import style0 from "./subjectiveQuestions.vue?vue&type=style&index=0&id=4d20e661&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d20e661",
  null
  
)

export default component.exports